export default "__VITE_ASSET__QCHjRWMF__"